import * as React from 'react';
import { Page } from '@ui/components';
import Requests from '@ui/scenes/Requests';

const RequestsPage = () => (
  <Page>
    <Requests />
  </Page>
);

export default RequestsPage;



// WEBPACK FOOTER //
// ./src/pages/Requests/Requests.tsx